var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadaesl24PxBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "import_contacts-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-\\u6CA1\\u6709list",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "import_contacts-24px"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,5 C19.89,4.65 18.67,4.5 17.5,4.5 C15.55,4.5 13.45,4.9 12,6 C10.55,4.9 8.45,4.5 6.5,4.5 C4.55,4.5 2.45,4.9 1,6 L1,20.65 C1,20.9 1.25,21.15 1.5,21.15 C1.6,21.15 1.65,21.1 1.75,21.1 C3.1,20.45 5.05,20 6.5,20 C8.45,20 10.55,20.4 12,21.5 C13.35,20.65 15.8,20 17.5,20 C19.15,20 20.85,20.3 22.25,21.05 C22.35,21.1 22.4,21.1 22.5,21.1 C22.75,21.1 23,20.85 23,20.6 L23,6 C22.4,5.55 21.75,5.25 21,5 Z M21,18.5 C19.9,18.15 18.7,18 17.5,18 C15.8,18 13.35,18.65 12,19.5 L12,8 C13.35,7.15 15.8,6.5 17.5,6.5 C18.7,6.5 19.9,6.65 21,7 L21,18.5 Z",
    id: "\\u5F62\\u72B6",
    fill: "#0E78D5",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadaesl24PxBlue);
export default __webpack_public_path__ + "static/media/badaesl-24px-blue.305eaa53.svg";
export { ForwardRef as ReactComponent };